import { Type } from 'class-transformer';
import { SORespProject } from '../project/so-resp-project';
import { SORespOrganization } from '../organization/so-resp-organization';
import {ENRequirementStatus} from '../../enums';
import {ObjectiveProtocol} from 'lionheartland';
import {CustomLogicRequirement} from "../../dexie/db";

export class SORespCustomLogicRequirement implements ObjectiveProtocol {

  entityType: string = 'customLogicRequirement';
  uid: string;
  name: string;
  description: string = "";
  active: boolean;
  currentStatus: ENRequirementStatus;
  @Type(() => SORespCustomLogicRequirement)
  parent: SORespCustomLogicRequirement = null;
  @Type(() => SORespProject)
  project: SORespProject;
  @Type(() => SORespOrganization)
  organization: SORespOrganization;

    toCustomLogicRequirement(): CustomLogicRequirement {
        return {
            uid: this.uid,
            name: this.name,
            description: this.description,
            dateCreated: null,
            active: this.active,
            currentStatus: this.currentStatus,
            customLogicRequirementsUid: null,
            parentUid: this.parent ? this.parent.uid : null,
            blocksUid: null,
            simpleAttributesUid: null,
            relationshipAttributesUid: null,
            projectUid: this.project ? this.project.uid : null,
            organizationUid: this.organization ? this.organization.uid : null,
}

        };
}